import React from "react";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { ResponsiveImage } from "@quintype/components";
import "./leadership-hero.m.css";

export const LeadershipHero = ({ collection }) => {
  const fallbackImage = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "fallback-image"], "")
  );


  if (!collection) return null;

  const title = get(collection, ["name"], "");
  const coverImage = get(collection, ["cover-image"]) || get(collection, ["metadata", "cover-image"]) || {};

  let coverImageUrl = coverImage["cover-image-url"] || coverImage["url"];

  // Robust check: If URL is missing or is just the CDN host (e.g. ends in .com/), use fallback
  if (!coverImageUrl || coverImageUrl.endsWith(".com/")) {
    coverImageUrl = fallbackImage;
  }

  const description = get(collection, ["metadata", "lif-description"], "");

  return (
    <div styleName="hero-banner-wrapper">
      <div styleName="image-background">
        <div styleName="hero-img-wrapper">
          <img src={coverImageUrl || fallbackImage} alt={title} />
        </div>
        {title && <div styleName="title">{title}</div>}
        <div styleName="content-container">
          <div styleName="content-overlay">
            {title && <div styleName="title">{title}</div>}
            {description && <h1 styleName="description">{description}</h1>}
          </div>
        </div>
      </div>
    </div>
  );
};
